export default {
  description:
    'Currently enabled languages on this page, consumers can only select them when switching languages; the consumer page will prioritize displaying the default language',
  language: 'Language',
  defaultLanguage: 'Default Language',
  enabled: 'Is Enabled',
  traditionalChinese: 'Traditional Chinese',
  simplifiedChinese: 'Simplified Chinese',
  english: 'English',
  japanese: 'Japanese',
  save: 'Save',
  saveSuccess: 'Saved successfully',
};
